import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { TransactionRequest } from "shared/models/transaction.model";
import { DataResponse } from "../shared/models";

export const transactionService = createApi({
  reducerPath: "transactionService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getTransactions: builder.query<any, TransactionRequest>({
      query: (params) => ({
        url: `/report/transactions`,
        method: "GET",
        params,
        headers: !params?.skip_log
          ? {
              PageName: "Transaction",
            }
          : {},
      }),
    }),
    getTransactionSyncByRefId: builder.query<any, {reference: string,include: any}>({
      query: (params) => ({
        url: `/report/transactions`,
        method: "GET",
        params,
        headers: {
          PageName: "Transaction",
        },
      }),
    }),
    getDetailTransactions: builder.query<any, { id: string }>({
      query: (params) => ({
        url: `/report/transactions/${params?.id}`,
        method: "GET",
        headers: {
          PageName: "Transaction",
        },
      }),
    }),
    getLogsTransactions: builder.query<any, { id: string }>({
      query: (params) => ({
        url: `/report/transactions/logs/${params?.id}`,
        method: "GET",
        headers: {
          PageName: "Transaction Logs",
        },
      }),
    }),
    getDetailRefundRequestTransactions: builder.query<any, { id: string }>({
      query: (params) => ({
        url: `/refund-request/${params?.id}`,
        method: "GET",
        headers: {
          PageName: "Transaction",
        },
      }),
    }),
    declineRefundRequestTransactions: builder.mutation<DataResponse<any>, any>({
      query: ({ id, ...others }) => ({
        url: `/refund-request/${id}/decline`,
        body: { ...others },
        method: "PUT",
        headers: {
          PageName: "Transaction",
        },
      }),
    }),
    approvalRefundRequestTransactions: builder.mutation<DataResponse<any>, any>({
      query: ({ id, ...others }) => ({
        url: `/refund-request/${id}/approval`,
        body: { ...others },
        method: "PUT",
        headers: {
          PageName: "Transaction",
        },
      }),
    }),
  }),
});

export const {
  useLazyGetTransactionsQuery,
  useLazyGetDetailTransactionsQuery,
  useGetTransactionsQuery,
  useLazyGetTransactionSyncByRefIdQuery,
  useLazyGetLogsTransactionsQuery,
  useLazyGetDetailRefundRequestTransactionsQuery,
  useDeclineRefundRequestTransactionsMutation,
  useApprovalRefundRequestTransactionsMutation,
} = transactionService;
